import React, { FC, useContext, useEffect, useState } from 'react';

import { CircleExclamation } from '@gravity-ui/icons';
import { Card, Text } from '@gravity-ui/uikit';
import { CurrentAliceAppContext } from 'client/context/aliceAppContext';
import { DraftStatus } from 'client/model/draft';
import { OperationType } from 'client/model/operation';

import { STATUS_TO_THEME_MAP } from '../OperationStatus/OperationStatus';

import styles from './Notes.module.scss';

const getCommentKey = (userUid: string, appId: string) => `last_displayed_comment__${appId}__${userUid}`;

const getLastComment = (userUid: string, appId: string) => {
    let lastComment: string | null = '';
    try {
        lastComment = localStorage.getItem(getCommentKey(userUid, appId));
    } catch (_e) {
        console.error('localStorage.getItem is not available');
    }
    return lastComment;
};

const setLastComment = (userUid: string, appId: string, comment: string) => {
    try {
        localStorage.setItem(getCommentKey(userUid, appId), comment);
    } catch (_e) {
        console.error('localStorage.setItem is not available');
    }
};

export const ModeratorNotes: FC = () => {
    const [showModerationNotes, setShowModerationNotes] = useState(false);
    const { aliceApp, lastOperationComment, lastOperationType } = useContext(CurrentAliceAppContext)!;
    const { user } = __appConfig;

    const userUid = user?.blackbox?.uid || '';
    const appId = aliceApp?.id || '';
    const displayComment =
        (aliceApp.draft.status === DraftStatus.ReviewApproved && lastOperationType === OperationType.ReviewApproved) ||
        (aliceApp.draft.status === DraftStatus.InDevelopment && lastOperationType === OperationType.ReviewCancelled)
            ? lastOperationComment
            : '';

    useEffect(() => {
        const lastSavedComment = getLastComment(userUid, appId);
        if (lastOperationType && displayComment && lastSavedComment !== displayComment) {
            setShowModerationNotes(true);
            setLastComment(userUid, appId, displayComment);
        }
    }, [displayComment, lastOperationType, userUid, appId]);

    if (!lastOperationType || !displayComment || !showModerationNotes) return null;

    return (
        <Card
            className={styles.moderationNotesContainer}
            theme={STATUS_TO_THEME_MAP[lastOperationType]?.theme || 'info'}
        >
            <Text
                className={styles.moderationHeader}
                color={STATUS_TO_THEME_MAP[lastOperationType]?.color || 'info-heavy'}
            >
                {STATUS_TO_THEME_MAP[lastOperationType]?.icon || <CircleExclamation />}
                {STATUS_TO_THEME_MAP[lastOperationType]?.label}
            </Text>
            <p className={styles.moderationText}>{displayComment}</p>
        </Card>
    );
};
